module.exports = __webpack_public_path__ + "static/media/coffe-break-ad.49605723.jpeg";